/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { SuccessView } from '../models/SuccessView';
import type { TwoFactorCodeRequest } from '../models/TwoFactorCodeRequest';
import type { TwoFactorSetupView } from '../models/TwoFactorSetupView';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class TwoFactorAuthenticationService {
    /**
     * Generate 2FA secret and provisioning URI
     * Returns an existing pending secret if still valid, otherwise generates a new one. The secret is locked for 15 minutes to prevent multi-device/restart issues. The user must confirm setup by calling /confirm with a valid code.
     * @returns TwoFactorSetupView 2FA setup data (may be reused from an active pending session)
     * @throws ApiError
     */
    public static postApp2FaSetup(): CancelablePromise<TwoFactorSetupView> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v2/api/user/2fa/setup',
            errors: {
                400: `2FA already enabled`,
            },
        });
    }
    /**
     * Confirm 2FA setup with a TOTP code
     * Verifies the TOTP code against the previously generated secret. If valid, enables 2FA for the user.
     * @param requestBody
     * @returns SuccessView 2FA enabled successfully
     * @throws ApiError
     */
    public static postApp2FaConfirm(
        requestBody: TwoFactorCodeRequest,
    ): CancelablePromise<SuccessView> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v2/api/user/2fa/confirm',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid code or no pending setup`,
            },
        });
    }
    /**
     * Disable 2FA
     * Disables two-factor authentication. Requires a valid TOTP code. Refused with errorCode `two_factor_locked_by_data_source` (HTTP 409) when the user still has a connected DataSource — delete the data source first.
     * @param requestBody
     * @returns SuccessView 2FA disabled successfully
     * @throws ApiError
     */
    public static deleteApp2FaDisable(
        requestBody: TwoFactorCodeRequest,
    ): CancelablePromise<SuccessView> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/v2/api/user/2fa',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `2FA not enabled or invalid code`,
                409: `Refused: a DataSource is still connected (errorCode: two_factor_locked_by_data_source)`,
            },
        });
    }
}
